// Module
var code = `<tft-notification ng-repeat="message in notificationPlaceholderCtrl.messages" message="message" on-close="notificationPlaceholderCtrl.closeMessage(message)"> </tft-notification>`;
// Exports
export default code;